import axios from "axios";


export default class Userservices {

  static getuserprofile(token: any) {
    return axios.get(process.env.REACT_APP_USER_PROFILE_DATA_API as string, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
  }

  static Changepassword(currentpassword: any, newpassword: any, token: any) {
    return axios.post(process.env.REACT_APP_CHANGE_PASSWORD_API as string, {
      "oldPassword": currentpassword,
      "newPassword": newpassword
    },{
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
  }

}
